import { useLazyQuery } from '@apollo/client'
import { FC, useEffect, useState } from 'react'

import { ME_QUERY } from '../../graphql/queries'
import { initialValues, ProfileContext } from './ProfileContext'

interface ProfileContextProviderProps {
  children: React.ReactNode
}

export const ProfileContextProvider: FC<ProfileContextProviderProps> = ({ children }) => {
  const [me, setMe] = useState<any>(initialValues.me)

  const [refetch, { data }] = useLazyQuery(ME_QUERY, {
    fetchPolicy: 'network-only'
  })

  useEffect(() => {
    setMe({ ...data?.me })
  }, [data, setMe])

  return (
    <ProfileContext.Provider
      value={{
        me,
        setMe,
        refetch
      }}
    >
      {children}
    </ProfileContext.Provider>
  )
}

export default ProfileContextProvider
